import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Config from '../../commons/config/Config.js'
import Loading from '../ui/Loading.js'

class EricInspeccionPanel extends Component {
	constructor(props) {
		super(props)
		this._mounted = false
		this.state = {
			loading: true,
			inspeccion: null,
		}
	}

	componentWillMount() {
		this._mounted = true
		this.cargar()
	}

	componentWillUnmount() {
		this._mounted = false
	}

	cargar() {
		var component = this
		var url = Config.get('apiUrlBase') + '/v1/inspections/by-checklist/' + this.props.formularioId
		fetch(url, {
			headers: { 'Authorization-Token': localStorage.getItem('token') }
		})
		.then(function(response) {
			if (!component._mounted) return null
			if (response.status === 404) {
				component.setState({ loading: false })
				return null
			}
			return response.json()
		})
		.then(function(data) {
			if (!component._mounted || !data) return
			component.setState({ inspeccion: data, loading: false })
		})
		.catch(function() {
			if (component._mounted) component.setState({ loading: false })
		})
	}

	renderEstadoBadge(estado) {
		var clases = {
			COMPLETADA: 'badge badge-success',
			PROCESANDO: 'badge badge-warning',
			FALLIDA:    'badge badge-danger',
			RECHAZADA:  'badge badge-secondary',
			INCOMPLETA: 'badge badge-light',
		}
		var etiquetas = {
			COMPLETADA: 'Completada',
			PROCESANDO: 'Procesando',
			FALLIDA:    'Fallida',
			RECHAZADA:  'Rechazada',
			INCOMPLETA: 'Incompleta',
		}
		return <span className={clases[estado] || 'badge badge-secondary'}>{etiquetas[estado] || estado}</span>
	}

	renderContent(inspeccion, discrepancias) {
		return (
			<div className="d-flex align-items-center flex-wrap" style={{ gap: '6px' }}>
				<i className="fa fa-camera mr-1 text-muted"></i>
				<Link to={'/eric/' + inspeccion.id} style={{ fontWeight: 600 }}>
					Eric IA — Inspección #{inspeccion.id}
				</Link>
				{this.renderEstadoBadge(inspeccion.estado)}
				{discrepancias.map(function(d, i) {
					return (
						<span key={i} className="badge badge-warning">
							<i className="fa fa-exclamation-triangle mr-1"></i>{d}
						</span>
					)
				})}
			</div>
		)
	}

	render() {
		var variant = this.props.variant || 'abm'

		if (this.state.loading) {
			return <span className="text-muted small"><i className="fa fa-spinner fa-spin mr-1"></i></span>
		}

		var inspeccion = this.state.inspeccion
		if (!inspeccion) return null

		var problemas = inspeccion.ocr_problemas || []
		var discrepancias = []
		if (inspeccion.flag_patente_discrepancia) discrepancias.push('Patente')
		if (problemas.some(function(p) { return p.tipo_campo === 'VIN' }))      discrepancias.push('VIN')
		if (problemas.some(function(p) { return p.tipo_campo === 'ODOMETRO' })) discrepancias.push('Odómetro')

		if (variant === 'detail') {
			return this.renderContent(inspeccion, discrepancias)
		}

		return (
			<div className="row">
				<div className="col-md-6">
					<div className="form-group row mb-1">
						<div className="col-md-9 offset-md-3">
							{this.renderContent(inspeccion, discrepancias)}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default EricInspeccionPanel
